import React, {Component} from 'react'
import PropTypes from "prop-types";
import PatientSelectComponent from "../single_components/PatientSelectComponent";
import {authenticationService} from "../../services/AuthenticationService";
import Error from "../single_components/Error";

class RequestMedicalInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,
            isOtherMedicalCondition: false,
            isOtherAllergics: false,
            patient_allergics: this.props.patient_allergics,
        }
    }

    componentDidMount() {
        let {isOtherMedicalCondition, patient_allergics, isOtherAllergics} = this.state

        for (let i = 0; i < patient_allergics.length; i++) {
            if (patient_allergics[i].value.toString() === "6") {
                isOtherAllergics = true
                break
            }
        }

        this.setState({isOtherMedicalCondition, isOtherAllergics})
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }


    handleAllergicsMultiChange(option) {
        let isOtherAllergics = false
        for (let i = 0; i < option.length; i++) {
            if (option[i].value === 6) {
                isOtherAllergics = true
                break
            }
        }
        if (!isOtherAllergics) {
            this.props.onValueChange("OtherAllergics", "")
        }
        this.setState({isOtherAllergics})
        this.props.onClickPatientAllergics(option)
    }

    handleMedicalDiagnoseChange(option) {
        this.onChangeDiagnose(option, "medical_diagnoses_icd_name", "medical_diagnoses_icd_code")
    }

    handleAnotherMedicalDiagnoseChange(option) {
        this.onChangeDiagnose(option, "Another_Medical_diagnoses_icd_name", "Another_Medical_diagnoses_icd_code")
    }


    render() {
        let {t,requestFromVisit} = this.props

        let {entry, isOtherAllergics} = this.state
        let allergics = this.props.allergics
        let allergicOptions = allergics?[allergics.length]:[]
        let currentUser = authenticationService.currentUserValue;
        let language = localStorage.getItem('language')


        for (let i = 0; i < allergics.length; i++) {
            if (language === "he") {
                allergicOptions[i] = {value: allergics[i].index, label: allergics[i].Allergic_name_he}
            } else {
                allergicOptions[i] = {value: allergics[i].index, label: allergics[i].Allergic_name}
            }
        }



        return (
            <div className={'patientsFormBoxes'}>


                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsHalf-height'}>
                        <div className='flex-Display'>
                            <label className={'infoLabel'}>{t('patient_self_boarding.choose_allergic')}</label>
                        </div>
                        <PatientSelectComponent
                            disabled={requestFromVisit}
                            placeholder=""
                            selectWidth={'700px'}
                            options={allergicOptions}
                            isMulti={true}
                            value={this.props.patient_allergics}
                            onChange={this.handleAllergicsMultiChange.bind(this)}
                        />
                    </div>

                    <div className={'inputSlots'} style={{display: isOtherAllergics ? 'block' : 'none'}}>
                        <label className={'infoLabel'}>{t('patient_self_boarding.Enter_allergic')}</label>
                        <input disabled={requestFromVisit} className={'inputBoxStyle'} name="isOtherAllergics"
                               defaultValue={entry.OtherAllergics}
                               onChange={(event) => this.props.onValueChange("OtherAllergics", event.target.value)}/>
                    </div>
                </div>


                <div className={'patientsFormRow'}>
                    <div className={'inputSlots'}>
                        <div className='flex-Display'>
                            <label className={'infoLabel'}>{t('patient_self_boarding.Doctors_Referral')}</label>
                        </div>
                        <input disabled={requestFromVisit} className={'inputBoxStyle'} type="text" name="ID"
                               defaultValue={entry.referralDoc ? entry.referralDoc : entry.doctors_referral_name}
                               onChange={(event) => this.props.onValueChange(entry.referralDoc ? "entry.referralDoc" : "doctors_referral_name", event.target.value)}/>

                    </div>
                </div>

                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsFlex'} id={'drug'}>
                        <div className={'infoLabel-error-block'}>
                            <label
                                className={'infoLabel-withError'}>{t('patient_self_boarding.transporter')}</label>
                        </div>

                        <button tabIndex={0}
                                className={entry.transporter === "Yes" ? 'inputBoxStyle-yes-no-left-selected' : 'inputBoxStyle-yes-no-left'}
                                onClick={() => this.props.onYesNoValueChange("transporter", "Yes")}>{t('patient_self_boarding.yes')}</button>
                        <button tabIndex={0}
                                className={entry.transporter === "No" ? 'inputBoxStyle-yes-no-right-selected' : 'inputBoxStyle-yes-no-right'}
                                onClick={() => this.props.onYesNoValueChange("transporter", "No")}>{t('patient_self_boarding.no')}</button>
                        {entry.transporter === "Yes" && <label
                            className={'infoLabel-transporter'}>{t('patient_self_boarding.upload_transporter_id')}</label>}

                    </div>
                </div>

                {entry.transporter === "Yes" &&
                    <>
                        <div className={'patientsFormRow'}>
                            <div className={'inputSlots'}>
                                <div className='flex-Display'>
                                    <label className={'infoLabel'}>{t('patient_self_boarding.transporterName')}</label>
                                </div>
                                <input className={'inputBoxStyle'} type="text" name="ID"
                                       defaultValue={entry.transporterName}
                                       onChange={(event) => this.props.onValueChange("transporterName", event.target.value)}/>
                            </div>
                            <div className={'inputSlots'}>
                                <div className='flex-Display'>
                                    <label
                                        className={'infoLabel'}>{t('patient_self_boarding.transporterID')}*</label>
                                    <Error isShown={!!(this.props.errors)['transporterID']}
                                           errorMessage={(this.props.errors)['transporterID']}/>
                                </div>
                                <input className={'inputBoxStyle'} type="text" name="ID"
                                       defaultValue={entry.transporterID}
                                       onChange={(event) => this.props.onValueChange("transporterID", event.target.value)}/>
                            </div>
                        </div>

                        <div className={'patientsFormRow'}>
                            <div className={'inputSlots'}>
                                <div className='flex-Display'>
                                    <label className={'infoLabel'}>{t('patient_self_boarding.transporterName2')}</label>
                                </div>
                                <input className={'inputBoxStyle'} type="text" name="ID"
                                       defaultValue={entry.transporterName2}
                                       onChange={(event) => this.props.onValueChange("transporterName2", event.target.value)}/>
                            </div>
                            <div className={'inputSlots'}>
                                <div className='flex-Display'>
                                    <label
                                        className={'infoLabel'}>{t('patient_self_boarding.transporterID2')}</label>
                                    <Error isShown={!!(this.props.errors)['transporterID2']}
                                           errorMessage={(this.props.errors)['transporterID2']}/>
                                </div>
                                <input className={'inputBoxStyle'} type="text" name="ID"
                                       defaultValue={entry.transporterID2}
                                       onChange={(event) => this.props.onValueChange("transporterID2", event.target.value)}/>
                            </div>
                        </div>


                    </>
                }

                <div className={'patientsFormRow-high'}>
                    <div className={'inputSlotsDoc-full'}>
                        <label className={'infoLabel'}>{t('patient_boarding.Comments')}</label>
                        <textarea className={'info-inputBoxStyle-visitSummary boxMargin'}
                                  defaultValue={entry.PatientComments} maxLength={"5000"}
                                  onChange={(event) => this.props.onValueChange("PatientComments", event.target.value)}/>
                    </div>
                </div>
                <div className={'blankSpace'}/>
            </div>

        )
    }
}

RequestMedicalInfo.propTypes = {
    onValueChange: PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default RequestMedicalInfo;
